/**
 * @flow
 * @relayHash 78ca8f4634b2fb7073821327d1ebcc7c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getAttendeesInviteesStatusQueryVariables = {|
  orgId: string,
  eventIds: $ReadOnlyArray<string>,
|};
export type getAttendeesInviteesStatusQueryResponse = {|
  +attendeesInviteesStatus: $ReadOnlyArray<{|
    +fullName: string,
    +inviteeStatus: ?string,
    +rsvpCancelReason: ?string,
  |}>
|};
export type getAttendeesInviteesStatusQuery = {|
  variables: getAttendeesInviteesStatusQueryVariables,
  response: getAttendeesInviteesStatusQueryResponse,
|};
*/


/*
query getAttendeesInviteesStatusQuery(
  $orgId: ID!
  $eventIds: [String!]!
) {
  attendeesInviteesStatus(orgId: $orgId, eventIds: $eventIds) {
    fullName
    inviteeStatus
    rsvpCancelReason
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "eventIds",
    "type": "[String!]!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventIds",
    "variableName": "eventIds"
  },
  {
    "kind": "Variable",
    "name": "orgId",
    "variableName": "orgId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inviteeStatus",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rsvpCancelReason",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getAttendeesInviteesStatusQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "attendeesInviteesStatus",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Attendee",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "getAttendeesInviteesStatusQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "attendeesInviteesStatus",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Attendee",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "getAttendeesInviteesStatusQuery",
    "id": null,
    "text": "query getAttendeesInviteesStatusQuery(\n  $orgId: ID!\n  $eventIds: [String!]!\n) {\n  attendeesInviteesStatus(orgId: $orgId, eventIds: $eventIds) {\n    fullName\n    inviteeStatus\n    rsvpCancelReason\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c39a4d95d85e4bd81fd013ffea955405';
module.exports = node;
